import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import ReminderDelete from '../../requests/tasks/user/ReminderDeleteTask';
import RequestManager from '../../requests/RequestManager';
import ReminderNotifications from '../../utils/RemindersNotifications/ReminderNotifications';
import store from '../../store';
import { setLastTouchReminder } from '../../reducers/user';
import logger from 'src/utils/logger/logger';
const reminderDelete = (reminder_id, cb) => {
  ReminderNotifications.clearTimeoutReminder(reminder_id);
  let service = new ReminderDelete(reminder_id);

  RequestManager.addRequest(service)
    .then(resp => {
      if(resp.lasttouch && resp.lasttouch.reminder) { // set new lasttouch Reminder in redux
        const lastTouchReminder = resp.lasttouch.reminder;
        store.dispatch(setLastTouchReminder(lastTouchReminder));
      }
      if (typeof cb === 'function') return cb(this);
    })
    .catch(err => {
      logger.debug('ACÁ ANDAMOS');

      logger.error(err);
    });
};

const ModalBorrarRecordatorio = props => {
  const defaultTile = Translator.get('delete_reminder_modal_title','Eliminar Recordatorio');
  const defaultContent = Translator.get('delete_reminder_modal_content','¿Estás seguro que deseas eliminar este recordatorio?');

  const p = {
    title: defaultTile,
    content: defaultContent,
    buttons: [
      {
        content: 'No',
        props: {
          onClick: e => props.handleClose(e, props.toggleVisibilityStatus)
        }
      },
      {
        content: 'Si',
        props: {
          onClick: e => {
            reminderDelete(props.reminder_id, props.service);
            props.handleClose(e, props.toggleVisibilityStatus);
          }
        }
      }
    ]
  };

  return <ModalWrapper {...p} />;
};

export default withOnClose(ModalBorrarRecordatorio);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalBorrarRecordatorio.jsx